import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

class UrlRegex extends Component {

    render() {
        const URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

        const anchorStyle = {
            "overflowWrap": "break-word",
        };

        const spanStyle = {
            "whiteSpace": "pre-wrap",
            "display": "block",
        };

        const value = this.props.value ?
            this.props.value.replace(/[\n]+/g, "\n ").split(" ")
                .map((part, index) =>
                    URL_REGEX.test(part) ?
                        <span style={spanStyle} key={index}>
                            <a target="_blank" style={anchorStyle} href={part}>{part}
                            </a>
                        </span > : part + " ")
            : "-"
        return (
            <div className="pl-0 col-12" style={{ whiteSpace: "pre-line" }}>
                {value}
            </div>
        )
    }

}

export default injectIntl(UrlRegex)


// WEBPACK FOOTER //
// ./src/common/regex/urlregex.component.jsx